import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'intNumber'
})
export class NumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (!value) {
      return '';
    } else {
      return Math.floor(value);
    }
  }

}
